// extracted by mini-css-extract-plugin
export default {"container":"Kids_container__Ogy3f","container__photo":"Kids_container__photo__ikLKd","photo":"Kids_photo__04UMe"};